"use client";

import { useState, useEffect } from "react";

export function TopBanner() {
  const [text, setText] = useState<string | null>(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    fetch("/api/settings")
      .then((r) => r.ok ? r.json() : null)
      .then((data) => {
        if (data) {
          setText(data.banner_text || null);
          setEnabled(data.banner_enabled === "true");
        }
      })
      .catch(() => {});
  }, []);

  if (!enabled || !text) return null;

  return (
    <div className="hidden bg-primary text-primary-foreground text-center py-1.5 text-sm font-medium md:block">
      {text}
    </div>
  );
}
